// extracted by mini-css-extract-plugin
export default {"Overlay-loading":"LoadingSpinner_Overlay-loading__cUhMw"};